module.exports = __webpack_public_path__ + "static/p7-3a21274cce90486615c74b06c2bc84aa.png";